import { render, staticRenderFns } from "./PageWorkoutProgramSkeleton.vue?vue&type=template&id=133cd814&scoped=true"
import script from "./PageWorkoutProgramSkeleton.vue?vue&type=script&lang=js"
export * from "./PageWorkoutProgramSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133cd814",
  null
  
)

export default component.exports